export default __webpack_public_path__ + "images/stripe-payment-element/amex-dc9159df18b2c16f5df50da324104174.svg";